// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsView from "../../../../engines/libs/utilsView";
import { MessageEventKind } from "../../../define/MessageEventKind";
import NormalGameManager from "../../manager/NormalGameManager";
import { OilFieldCollect } from "../oilfield/config/oilfieldDataHelp";

const {ccclass, property} = cc._decorator;

@ccclass
export default class OpenOilFieldCollectLayer extends BasePopUpLayer {

    @property({ type: cc.Node, displayName:'' })
	nodeCollect: cc.Node = null;

    @property(cc.Button)
    btnConfirm: cc.Button = null;

    @property({ type: cc.Node, displayName:'' })
	btnComClose: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodeLight: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodeRet: cc.Node = null;

    @property({ type: cc.Node, displayName:'' })
	nodeCom: cc.Node = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        this.nodeRet.active = false;   
        this.nodeCom.active = true;   
        this.nodeLight.active = false;
        this.refreshCollect();
        O1HD.getModules().uiControlModule.hideLoading();
    }

    refreshCollect() {
        let iCount = 0;
        let colletConfig = OilFieldCollect;
        this.nodeCollect.children.forEach((v, i)=> {
            let item = colletConfig[i];
            let goods = NormalGameManager._instance.getOneGood(item);
            v.active = true;
            if (!goods || goods.num <= 0)  {
                v.active = false;
            } else {
                iCount++;
            }
        });

        this.btnConfirm.interactable = iCount >= OilFieldCollect.length;
    }

    startAni() {
        this.nodeLight.active = true;
        this.nodeLight.opacity = 150;

        let t3 = 0.2;
        cc.tween(this.nodeLight)
        .to(t3, {opacity: 250})
        .parallel(
            cc.tween().to(0.25, {scale: 3})
            , cc.tween().to(0.25, {opacity: 255})
        )
        .call(()=> {
            this.nodeCom.active = false;   
            this.nodeRet.active = true;   
        })
        .to(t3, {opacity: 0})
        .call(this.finishComDispose.bind(this))
        .start();
    }

    async finishComDispose() {
        // NormalGameManager._instance.taskDataManage.addNewFinishTask(TaskKind.TaskId.TASK_4);
        // 
        // 

        NormalGameManager._instance.setGameData({bShowKongTongBtn: true});

        let colletConfig = OilFieldCollect;
        for (let o of colletConfig) {
            NormalGameManager._instance.onOutGoods(o, 1);
        }
        this.destroyNode();

        O1HD.emit(MessageEventKind.EventName.REFRESH_OilField_COLLECT_Finish);
        O1HD.emit(MessageEventKind.EventName.REFRESH_SPECIAL_BTN_STATE);
        // let addGoodsList = {};
        // addGoodsList[50014] = 1;
        // await utilsView.openGetGoodsLayer(0, 0, addGoodsList);
        // NormalGameManager._instance.onPushGoods(50014,1);
    }

    onClickFinish() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.finishComDispose();
    }

    onClickConfirm() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.btnComClose.active = false;
        this.btnConfirm.node.active = false;
        this.startAni();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }

    // update (dt) {}
}
